import _asyncToGenerator from "C:/GitLab-Runner/builds/VgMjNYji/0/billing/billingmalta/src/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { HeaderNames } from "./HeaderNames";
import { HttpClient } from "./HttpClient";
/** @private */
export class AccessTokenHttpClient extends HttpClient {
  constructor(innerClient, accessTokenFactory) {
    super();
    this._innerClient = innerClient;
    this._accessTokenFactory = accessTokenFactory;
  }
  send(request) {
    var _this = this;
    return _asyncToGenerator(function* () {
      let allowRetry = true;
      if (_this._accessTokenFactory && (!_this._accessToken || request.url && request.url.indexOf("/negotiate?") > 0)) {
        // don't retry if the request is a negotiate or if we just got a potentially new token from the access token factory
        allowRetry = false;
        _this._accessToken = yield _this._accessTokenFactory();
      }
      _this._setAuthorizationHeader(request);
      const response = yield _this._innerClient.send(request);
      if (allowRetry && response.statusCode === 401 && _this._accessTokenFactory) {
        _this._accessToken = yield _this._accessTokenFactory();
        _this._setAuthorizationHeader(request);
        return yield _this._innerClient.send(request);
      }
      return response;
    })();
  }
  _setAuthorizationHeader(request) {
    if (!request.headers) {
      request.headers = {};
    }
    if (this._accessToken) {
      request.headers[HeaderNames.Authorization] = `Bearer ${this._accessToken}`;
    }
    // don't remove the header if there isn't an access token factory, the user manually added the header in this case
    else if (this._accessTokenFactory) {
      if (request.headers[HeaderNames.Authorization]) {
        delete request.headers[HeaderNames.Authorization];
      }
    }
  }
  getCookieString(url) {
    return this._innerClient.getCookieString(url);
  }
}